<template>
  <div class="user-avatar-menu">
    <template v-if="user">
      <v-layout align-center>
        <p class="mb-0 mr-3">{{ user.username }}</p>
        <v-flex>
          <v-avatar
            :size="35"
            color="grey lighten-4"
          >
            <img :src="userAvatarUrl" alt="avatar">
          </v-avatar>
        </v-flex>
      </v-layout>
    </template>
  </div>
</template>

<script>
export default {
  name: 'UserAvatarMenu',
  computed: {
    user () {
      return this.$store.state.users.user
    },
    userAvatarUrl () {
      return this.$store.getters['users/gravatar']
    }
  }
}
</script>

<style>

</style>
